module.exports = __webpack_public_path__ + "static/BodoniSvtyTwoITCTT-Bold-198e07cd20a3b003fdb9a14a3c347f10.woff2";